import { createContext } from "react";

export const MeetingDateTypeContext = createContext({
  meetingDateTypes: undefined,
  createMeetingDateType: () => {},
});

export default MeetingDateTypeContext;
